module.exports = __webpack_public_path__ + "static/media/halasz_fishing_img01.da5dc62a.png";